(function () {
    'use strict';

    angular
        .module('edufindme')
        .controller('OpenInformationEdufindmeController', OpenInformationEdufindmeController);

    OpenInformationEdufindmeController.$inject = ['$uibModalInstance', 'client'];

    function OpenInformationEdufindmeController($uibModalInstance, client) {
        var vm = this;

        vm.client = client;
        vm.ok = ok;
        vm.cancel = cancel;

        activate();

        ////////////////

        function activate() {
            
        }

        function ok () {

            $uibModalInstance.close();

        }

        function cancel () {
            $uibModalInstance.close();
        }

    }

})();